// What the assistant panel says while one of this module's tools is running
// («Buscando entre las máquinas…»), in the four languages.
//
// A contract with `backend/assistant.js`, like the analytics vocabulary is with
// `backend/analytics.js`: every tool registered there gets the key
// `assistant.tools.<registered name>` — the name the platform gives it, with the
// module in front — and this file holds that key. The English here is the
// same sentence as the tool's `label`, which is what the panel shows when a
// key is missing. platform/web/tests/assistantToolLabels.test.js checks both:
// a tool without its four sentences, or an English one that drifted from the
// backend label, fails the suite.

const toolLabels = {
  es: {
    invoicing_find_invoices: 'Buscando entre las facturas',
    invoicing_invoice_file: 'Abriendo la factura',
    invoicing_invoicing_summary: 'Sumando la facturación',
    invoicing_unpaid_invoices: 'Mirando lo que nos deben',
    invoicing_orders_to_invoice: 'Buscando trabajo terminado por facturar',
    invoicing_invoice_from_order: 'Preparando la factura de la orden',
    invoicing_send_invoice: 'Enviando la factura al cliente',
    invoicing_register_payment: 'Registrando el cobro',
  },
  ca: {
    invoicing_find_invoices: 'Cercant entre les factures',
    invoicing_invoice_file: 'Obrint la factura',
    invoicing_invoicing_summary: 'Sumant la facturació',
    invoicing_unpaid_invoices: 'Mirant el que ens deuen',
    invoicing_orders_to_invoice: 'Buscant feina acabada per facturar',
    invoicing_invoice_from_order: 'Preparant la factura de l’ordre',
    invoicing_send_invoice: 'Enviant la factura al client',
    invoicing_register_payment: 'Registrant el cobrament',
  },
  en: {
    invoicing_find_invoices: 'Looking through the invoices',
    invoicing_invoice_file: 'Opening the invoice',
    invoicing_invoicing_summary: 'Adding up the invoicing',
    invoicing_unpaid_invoices: 'Checking what is owed',
    invoicing_orders_to_invoice: 'Looking for finished work to invoice',
    invoicing_invoice_from_order: 'Drafting the invoice for the order',
    invoicing_send_invoice: 'Sending the invoice to the customer',
    invoicing_register_payment: 'Registering the payment',
  },
  fr: {
    invoicing_find_invoices: 'Recherche parmi les factures',
    invoicing_invoice_file: 'Ouverture de la facture',
    invoicing_invoicing_summary: 'Bilan de la facturation',
    invoicing_unpaid_invoices: 'Ce qu’on nous doit',
    invoicing_orders_to_invoice: 'Recherche des travaux terminés à facturer',
    invoicing_invoice_from_order: 'Préparation de la facture de l’ordre',
    invoicing_send_invoice: 'Envoi de la facture au client',
    invoicing_register_payment: 'Enregistrement du paiement',
  },
}

/** The module's catalogue with its tool labels hung from `assistant.tools`, locale by locale. */
export function withToolLabels(base) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      assistant: {
        ...catalogue.assistant,
        tools: { ...catalogue.assistant?.tools, ...toolLabels[locale] },
      },
    }
  }
  return merged
}

export default toolLabels
